// 拿到封装好的网络请求工具包
import request from '../utils/request'
// 提交结果
export const getResults = data => request({
  method: 'post',
  url: '/api/classify/submit',
  // 要传的参数
  data,
  headers: { 'Token-Circus': window.localStorage.getItem("Token-Circus"), 'Unique-Ident': window.localStorage.getItem("umtId") }
})